module.exports = __webpack_public_path__ + "static/media/md-appstore.f9892ac3.svg";